/** @format */

import ProfileLeft from "../profileleft";
import {
  Container,
  HeaderImage,
  Display,
  HeroImage,
  SmallDiv,
  NewProducts,
  BottomText,
} from "./styles";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import wave from "../../../assets/images/waves pattern.svg";

const ServiceList = ({ goToTelephone, profile }: any) => {
  let [link, setLink] = useState<any>();
  let [hero, setHero] = useState<any>();

  const getLink = async () => {
    axios
      .get(`${API_URL}/links/${profile.businessUuid}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setLink(response.data.data);
        }
      })
      .catch((error) => {
        if (
          error?.response?.status === 400 ||
          error?.response?.status === 401
        ) {
          return;
        }
        toast.error("Connection Failed");
      });
  };
  const getHero = async () => {
    axios
      .get(`${API_URL}/heroandHeader/${profile?.businessUuid}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setHero(response?.data?.data);
        }
      })
      .catch((error) => {
        if (
          error?.response?.status === 400 ||
          error?.response?.status === 401
        ) {
          return;
        }
        toast.error("Connection Failed");
      });
  };
  const handleCount = async (id: number) => {
    const form = {
      businessUuid: profile?.businessUuid,
      id: id,
    };
    axios
      .post(`${API_URL}/link-click-count`, form)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
        }
      })
      .catch((error) => {
        if (
          error?.response?.status === 400 ||
          error?.response?.status === 401
        ) {
          return;
        }
      });
  };

  useEffect(
    () => {
      getLink();
      getHero();
    },
    // eslint-disable-next-line
    []
  );
  return (
    <>
      <Container>
        <HeaderImage>
          <img src={hero?.headerImage ? hero?.headerImage : wave} alt="" />
        </HeaderImage>
        <ProfileLeft goToTelephone={goToTelephone} profile={profile} />

        <Display>
          {
            hero?.heroImage ?
          <HeroImage>
            <img src={hero?.heroImage} alt="" />
          </HeroImage>
            :null
        }
          <SmallDiv>
            {link &&
              link.map((item: any) => (
                <NewProducts
                  key={item.id}
                  // @ts-ignore
                  isImportant={item?.isImportant}
                  onClick={() => {
                    handleCount(item.id);
                  }}
                >
                  <a
                    href={`${item?.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={item.image} alt="" />
                    {item.name === null || item.name === "" ? null : (
                      <div>{item.name}</div>
                    )}
                  </a>
                </NewProducts>
              ))}
          </SmallDiv>
        </Display>
      </Container>
      <BottomText>powered by path</BottomText>
    </>
  );
};

export default ServiceList;
